import { registerPackageResources } from '@inbody/core';

import en from './en.json';
import ko from './ko.json';

const namespace = 'ui';

declare module 'i18next' {
  interface I18nNamespaces {
    [namespace]: typeof ko;
  }
}

// i18n 리소스
export const uiResources = {
  ko: {
    [namespace]: ko,
  },
  en: {
    [namespace]: en,
  },
};

registerPackageResources({
  namespace: namespace,
  resources: uiResources,
});
